/**
 * UUID v4 también fuera de contexto seguro.
 *
 * `crypto.randomUUID` solo existe con https o localhost. En un preview servido
 * por http con una IP (entornos de revisión) no está, y como lo usa cada
 * petición a la API (`X-Request-Id`), la app no podía ni iniciar sesión.
 * `crypto.getRandomValues` sí está disponible ahí.
 */
export function randomId(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
